import { Receipt, LineChart, FileText, MessageCircleQuestion } from "lucide-react";

const ITEMS = [
  { icon: Receipt, title: "A clear read of your bill", desc: "Help understanding your current electric usage, rate class, riders, and where the costs actually come from." },
  { icon: LineChart, title: "A side-by-side comparison", desc: "When appropriate, I'll compare your current utility costs with an ION Solar proposal built for your home." },
  { icon: FileText, title: "A plain-language walk-through", desc: "What eligibility looks like, how a Power Purchase Agreement works, agreement terms, and what each next step involves." },
  { icon: MessageCircleQuestion, title: "Honest answers — no obligation", desc: "Questions answered on your schedule. If solar doesn't make sense for your home, I'll tell you." },
];

export default function WhatYouGet() {
  return (
    <section className="py-20 md:py-28 bg-[#FDFBF7]" data-testid="what-you-get-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="eyebrow">What a Bill Review Gives You</div>
          <h2 className="mt-3 font-serif-display text-3xl md:text-5xl font-semibold text-[#0F382C] leading-tight">
            Send me your bill. Get real answers.
          </h2>
          <p className="mt-4 text-slate-600 text-base md:text-lg">
            Here's what you can expect when you reach out — no pressure, no obligation to proceed.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {ITEMS.map((it) => (
            <div key={it.title} className="card-warm p-6">
              <div className="w-11 h-11 rounded-xl bg-[#0F382C] flex items-center justify-center">
                <it.icon className="w-5 h-5 text-[#FEF3C7]" />
              </div>
              <h3 className="mt-4 font-serif-display text-lg text-[#0F382C] leading-snug">{it.title}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{it.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
